import styled from "styled-components";
import { dispositivo } from "../../components/Dispositivos";

const btn = `
 height: 2.5rem;
 width: 100%;
 border-radius: 1em;      
 text-transform: uppercase;
 cursor: pointer;
 font-width: bold;
 font-size: 0.9rem;
 
 @media ${dispositivo.mobileS}{
   font-size: 0.9rem;
   padding: 0.1em;  
 }
`;

export const RegistroWrapper = styled.div`
  display: block;
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  align-items: center;
  background: #f8f8f8;
  justify-content: center;
`;
export const ContainerTitle = styled.div`
  color: #000;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  padding: 2%;
  margin-top: 10px;
`;

export const ContainerTitleText = styled.h2`
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  padding: 1%;
  margin-top: 5px;
`;

export const ContainerLeft = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-bottom: 1rem;
`;
export const StyledButton = styled.button`
  height: 2.25rem;
  border-radius: 0.8rem;
  width: 7rem;      
  text-transform: uppercase;
  cursor: pointer;
  font-width: bold;
  background-color: #0060b0;
  color: #ffffff;
  font-size: 0.75rem;
  border: none;
  &:hover{
    color:#000000;
    background-color: #0c8de390;
    font-width: bold;
  }
  @media ${dispositivo.mobileL} {
    font-size: 1rem;
  }
  @media ${dispositivo.tablet}{
    width: 10rem;
  }  
  @media ${dispositivo.laptop} {      
    width: 12.5rem;
  }
`;
export const StyledLabel = styled.label`
  font-weight: bold;
  text-align: left;
  color: #040404;
`;
export const DivInput = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  .button-wrapper{
    display: flex;
    flex-direction: column;
    height: 2.25rem;
    text-align: center;
    cursor: pointer;
    border-radius: 10px;
    width: 80%;
    @media ${dispositivo.mobileL} {
      width: 80%;
    }
  }
  .label{
    position: relative;
    z-index: 0;
    display: inline-block;
    border-radius: 10px;
    background-color: #64bdff30;
    color: #0D0808;
    cursor: pointer;
    padding: 8px 0;
    font-size: 0.75rem;
    @media ${dispositivo.tablet} {
      font-size: 1rem;
    }
  }
  .upload-box {
    display: inline-block;
    position: absolute;
    z-index: 1;
    opacity: 0;
    cursor: pointer;
    width: 33%;
}
`;

export const StyledTextArea = styled.textarea`
  height: auto; /* Para permitir ajuste según el contenido */
  min-height: 6em; /* Aproximadamente 3 líneas */
  border-radius: 10px;
  background-color: #64bdff30;
  border: none;
  outline: none;
  color: #0D0808;
  padding: 0.5em 1em; /* Ajuste para mejorar la apariencia */
  line-height: 1.5; /* Espaciado entre líneas */
  font-size: 0.75rem;
  width: 60%;
  resize: vertical; /* Permite al usuario ajustar el tamaño */
  
  &::placeholder {
    color: #04000060;
    font-size: 0.5rem; /* Corrección de typo */
  }

  &:focus {
    border: 2px solid #0060b0;
  }

  @media ${dispositivo.mobileL} {
    width: 80%;
  }

  @media ${dispositivo.tablet} {
    font-size: 1rem;
  }
`;



export const StyledInput = styled.input`
  height: 2.5rem;
  border-radius: 10px;
  background-color: #64bdff30;
  border: none;
  outline: none;
  color: #0D0808;
  padding-left: 1em;
  line-height: 2.5;
  font-size: 0.75rem;
  width: 60%;
  &::placeholder {
    color: #04000060;
    fonst-size: 0.5rem;
  }
  &:focus{
    border: 2px solid #0060b0;
  }
  @media ${dispositivo.mobileL} {
    width: 80%;
  }
  @media ${dispositivo.tablet} {
    font-size: 1rem;
  }
`;
export const StyledSelect = styled.select`
  padding: 8px;
   
  background-color: #64bdff30;
  border-radius: 4px;
  margin-right: 8px;
  width: 23%;
  height: 40px;
  font-size: 14px;
  margin-left: auto; // Esto empujará el select hacia la derecha
  
`;

export const StyledInputPhone = styled.input`
  padding: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  width: 42%; // Ancho fijo para mantener consistencia con otros inputs
  height: 40px;
  
  background-color: #64bdff30;
  font-size: 14px;
   &::placeholder {
    color: #04000060;
    fonst-size: 0.5rem;
  }
  &:focus{
    border: 2px solid #0060b0;
  }
  @media ${dispositivo.mobileL} {
    width: 80%;
  }
  @media ${dispositivo.tablet} {
    font-size: 1rem;
  }
`;

export const PhoneContainer = styled.div`
  display: flex;
  align-items: center;
  width: 60%;
  justify-content: flex-end; // Alinea los elementos a la derecha
  gap: 8px;
`;
export const RegistroFormWrapper = styled.section`
  background: #fff;
  border-radius: 8px;
  justify-content: center;
  text-align: center;
  align-items: center;
  margin: 2% 5% 5% 5% ;
  padding: 1rem;
  @media ${dispositivo.tablet} {
    margin: 2% 15% 5% 15% ;
  }
`;
export const StyledForm = styled.div`
  width: 100%;
  height: 100%;
  padding: 2%;
  background: #fff;
  display: block;
  justify-content: center;
  border-radius: 10px;
  border: 2px solid #0c8de3;
  margin-bottom: 1rem;
`;
export const FooterWrapper = styled.footer`
 background: #EBF0FC;
 left: 400px;
 position: fixed;
 @media (max-width: 1024px) {
   display: none;
 }
 .carouselHeigth{
   height: 100%;
 } 
`;